import React from "react";
import styles from "./EditableField.module.css";
import clsx from "clsx";

interface EditableFieldProps {
  isEditing: boolean;
  label: string;
  value: string;
  onChange?: (value: string) => void;
}

const EditableField: React.FC<EditableFieldProps> = ({
  isEditing,
  label,
  value,
  onChange,
}) => {
  return isEditing ? (
    <>
      <strong>{label}</strong>
      <textarea
        value={value ?? ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        className={clsx(styles["qc-textarea"], styles["qc-editing-mode"])}
      />
    </>
  ) : (
    <div className={styles["meta-data"]}>
      <p>
        <strong>{label} </strong>
        {value}
      </p>
    </div>
  );
};

export default EditableField;
